import { useLocation } from 'react-router-dom';

import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { Shops } from '@/Swagger';
import { queryKeys } from '@/app/queryKeys';
import axiosInstance from '@/axios/axios';
import type { ExtractQueryFunction, UseAxiosQueryOptions } from '@/utils/typeHelper';

type QueryOptions = UseAxiosQueryOptions<Shops.MaintenanceList.ResponseBody, [string, string]>;

const queryFn: ExtractQueryFunction<QueryOptions> = () => {
  return axiosInstance.get<Shops.MaintenanceList.ResponseBody>('/shops/maintenance').then(v => v.data);
};

/**
 * 점검 여부를 조회하는 API 입니다.
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Shops/get_shops_maintenance
 */
export function useGetMaintenance() {
  const location = useLocation();

  return useQuery({
    queryKey: [...queryKeys.maintenance, location.pathname] as const,
    queryFn,
    gcTime: 0,
  });
}
/**
 * 점검 여부를 조회하는 API 입니다. (suspense hook)
 */
export function useSuspenseGetMaintenance(options?: QueryOptions) {
  const location = useLocation();

  return useSuspenseQuery({
    queryKey: [...queryKeys.maintenance, location.pathname] as const,
    queryFn,
    ...options,
    gcTime: 0,
  });
}
